import RouterPath from 'libs/RouterPath';
import {clearResource, setStepperState} from 'redux/actions';
import reduxStore from 'redux/store'
import {ProcedureTypeTr} from "constants/ProcedureType";
import Tr from 'translations/Translations';

const createItem = (label, items, onClick, disabled = false) => ({
    label,
    items,
    onClick,
    disabled,
})

//#TODO: translations

const newDeamandFunction = (passive, procedureType) => {
    reduxStore.dispatch(clearResource('demand'))
    reduxStore.dispatch(clearResource('dealingsList'))
    reduxStore.dispatch(clearResource('dealing'))
    reduxStore.dispatch(clearResource('demandHeader'));
    //reduxStore.dispatch(clearResource('demandActions'));
    reduxStore.dispatch(setStepperState())
    RouterPath.redirectWithSearch(RouterPath.myProcedure.steps.MP_1, {passive, procedureType})
}
export default (procedures) => {

    return procedures.map(proc => {

        const items = [];
        if (proc.system) {
            items.push(createItem(Tr('activeForm'), undefined, () => newDeamandFunction(false, proc.procedureType)))
        }
        if (proc.passive) {
            items.push(
                createItem(Tr('passiveForm'), undefined, () => newDeamandFunction(true, proc.procedureType)))
        }
        return createItem(ProcedureTypeTr[proc.procedureType], items)
    })
}

